import { getEventPropsBuilder, getJackpotData, getMultiplierLabel, getPageName } from '../../utils';
import type { AmplitudeEventKeys } from '../../amplitude-properties.types';
import type { UpdatedJackpotTier } from '@/types/zones/slices/site-wide-jackpot-slice';

type SwjOptInOnEvent = {
    multiplier: number;
    updatedTiers: UpdatedJackpotTier[];
};

type SwjOptInOffEvent = {
    previousMultiplier: number;
    updatedTiers: UpdatedJackpotTier[];
};

const PAGE_TO_MODULE: Record<string, string> = {
    home: 'lobby',
    category: 'landing_page',
    game_window: 'game_window'
};

const getModalOpenedModule = (): string => PAGE_TO_MODULE[getPageName()] ?? 'lobby';

export const getSwjOptInOnProps = getEventPropsBuilder(
    (e: SwjOptInOnEvent): Partial<AmplitudeEventKeys> => ({
        event: 'FDC Jackpots Opt In On Toggled',
        Module: 'fdc_jackpots',
        'Page Name': getPageName(),
        'FDC Jackpot Opt In Status': 'opted_in',
        'FDC Jackpot Multiplier': getMultiplierLabel(e.multiplier),
        ...getJackpotData(e.updatedTiers)
    })
);

export const getSwjOptInOffProps = getEventPropsBuilder(
    (e: SwjOptInOffEvent): Partial<AmplitudeEventKeys> => ({
        event: 'FDC Jackpots Opt In Off Toggled',
        Module: 'fdc_jackpots',
        'Page Name': getPageName(),
        'FDC Jackpot Opt In Status': 'opted_in',
        'FDC Jackpot Multiplier': getMultiplierLabel(e.previousMultiplier),
        ...getJackpotData(e.updatedTiers)
    })
);

export const getSwjModalOpenedProps = getEventPropsBuilder(
    (multiplier: number, updatedTiers: UpdatedJackpotTier[], module?: string): Partial<AmplitudeEventKeys> => ({
        event: 'FDC Jackpots Modal Viewed',
        Module: module ?? getModalOpenedModule(),
        'Page Name': getPageName(),
        'FDC Jackpot Opt In Status': multiplier > 0 ? 'opted_in' : 'opted_out',
        'FDC Jackpot Multiplier': getMultiplierLabel(multiplier),
        ...getJackpotData(updatedTiers)
    })
);

export const getSwjTrackerToggleProps = getEventPropsBuilder(
    (
        multiplier: number,
        updatedTiers: UpdatedJackpotTier[],
        linkText: 'show_tracker' | 'hide_tracker'
    ): Partial<AmplitudeEventKeys> => ({
        event: 'Navigation Link Clicked',
        Module: 'opt_in_sheet',
        'Page Name': getPageName(),
        'FDC Jackpot Opt In Status': multiplier > 0 ? 'opted_in' : 'opted_out',
        'FDC Jackpot Multiplier': getMultiplierLabel(multiplier),
        'Link Text': linkText
    })
);

export const getSwjModalClosedProps = getEventPropsBuilder(
    (multiplier: number, updatedTiers: UpdatedJackpotTier[], module?: string): Partial<AmplitudeEventKeys> => ({
        event: 'FDC Jackpots Modal Closed',
        Module: module ?? getModalOpenedModule(),
        'Page Name': getPageName(),
        'FDC Jackpot Opt In Status': multiplier > 0 ? 'opted_in' : 'opted_out',
        'FDC Jackpot Multiplier': getMultiplierLabel(multiplier),
        ...getJackpotData(updatedTiers)
    })
);
